import baseEvents from './../config/baseEvents';

export default function RailsFactory(
    $filter,
    $rootScope,
    RailSearchParams,
    userService,
    sessionService,
    l10nService,
    appCONST,
    loginFactory,
    railsApiService,
    railsUtils
) {
    'ngInject';

            const _rails = {};
            const _params = {};

            return function(module) {

                const FREQUENT_FLIGHTS_COUNT = 3;

                // Initialize or reuse _rails results for a given module
                if (!_rails[module]) {
                    _rails[module] = {};
                }
                let rails = _rails[module];


                // Initialize or reuse _rails results for a given module
                if (!_params[module]) {
                    _params[module] = new RailSearchParams(module);
                }
                const params = _params[module];

                /**
                 * Localization settings
                 */
                const regionalSettings = userService.getRegionalSettings();

                /**
                 * Comparison filter
                 */
                let comparisonFilter = null;


                const labels = {
                    flights: {
                        items: 'Flights',
                        findItems: 'Find flights',
                        operators: 'Airlines',
                        stations: 'Airports',
                        stoppage: {
                            title: 'Stops',
                                keys: {
                                    1: 'Non Stop',
                                    2: 'Stop',
                                    3: 'All',
                                },
                            },
                    },
                    trains: {
                        items: 'Trains',
                        findItems: 'Find eurostar',
                        operators: 'Operators',
                        stations: 'Stations',
                        stoppage: {
                            title: 'Changes',
                            keys: {
                                1: 'Direct',
                                2: 'Changes',
                                3: 'All',
                            },
                        },
                    },
                    ukrail: {
                    items: 'Rail Search',
                    findItems: 'Find UK Rail',
                operators: 'Operators',
                stations: 'Stations',
                stoppage: {
                    title: 'Changes',
                    keys: {
                        1: 'Direct',
                        2: 'Changes',
                        3: 'All',
                    },
                },
            },
                };

                const TRAINLINE_BOOK_DAYS_ADVANCE = 91;

                return {
                    TOP_PREV_SEARCHES_LIMIT: 3,
                    ALL_PREV_SEARCHES_LIMIT: 10,
                    segmentFilterData: {},
                    options: {
                        time: [],
                    },
                    params,
                    getSearch: railsApiService.getSearchRequestById,
                    getTimeOptions,
                    getFlights,
                    resetSegmentFilterData,
                    segmentFilterLength,
                    applySegmentFilterId,
                    fetchRails,
                    fetchExchangeRails,
                    fetchInwardEuRails,
                    fetchPageEuRails,
                    findFlights,
                    applyFilters,
                    loadMoreFlights,
                    filterBySegment,
                    getRules,
                    getTopPreviousSearches,
                    getAllPreviousSearches,
                    getFrequentRails,
                    getModule,
                    getStaticData,
                    getEarlierOrLaterJournies,
                    isFlights,
                    isTrains,
                    isUkRail,
                    getLabels,
                    getRailReservationPreferenceOptions,
                    getRailTravelCardOptions,
                    get showOptions() {
                        return railsUtils.moreOptionsApplied(this.params);
                    },
                    resetParams: function() {
                        _params[module] = this.params = new RailSearchParams(module);
                    },
                    getMaxBookDate,
                    getKioskRailStations,
                    getRailSearchByGuid,
                    getAddressByPostcode,
                    getAllCorpkiosks,
                    getCorpPrinters,
                    getCurrentUKTime,
                    saveAddress,
                    getAddressTypes,
                };

                function getFlights() {
                    return rails;
                }

                /**
                 * Applies a new segment to the list for filtering by segment
                 * Add segmentId or remove from list.
                 */
                function resetSegmentFilterData() {
                    this.params.SegmentFilterData = this.segmentFilterData = [];
                }

                function segmentFilterLength() {
                    const keys = [];
                    for (const key in this.segmentFilterData) {
                        if (this.segmentFilterData.hasOwnProperty(key)) {
                            keys.push(key);
                        }
                    }
                    return keys.length;
                }

                function applySegmentFilterId(flight) {
                    if (this.segmentFilterData.hasOwnProperty(flight.FlightGroupHash)) {
                        delete this.segmentFilterData[flight.FlightGroupHash];

                        if (this.segmentFilterLength === 0) {
                            this.segmentFilterData = [];
                        }
                    } else {
                        this.segmentFilterData[flight.FlightGroupHash] = [];
                        this.segmentFilterData[flight.FlightGroupHash].push(flight.FlightGroupId);
                    }

                    let tempArray = [];
                    for (const prop in this.segmentFilterData) {
                        if (this.segmentFilterData.hasOwnProperty(prop)) {
                            tempArray = tempArray.concat(this.segmentFilterData[prop]);
                        }
                    }

                    this.params.SegmentFilterData = tempArray;
                }

                function getRailSearchByGuid(guid) {
                    return railsApiService.getRailSearchRequestByGUId(guid)
                        .then((response) => {
                            rails = response.data;
                            return response;
                        });
                }

                function fetchRails(parameters, paramsPrepared, arrivalFlags) {
                    let request = parameters;

                    this.params.resetPagination();

                    comparisonFilter = null;
                    delete parameters.SearchId;

                    if (!paramsPrepared) {
                        request = this.params.getSearchRequestParams(arrivalFlags);
                    }

                    return railsApiService.search(request)
                        .then((data) => {
                                rails = data;
                                _rails[module] = data;
                                this.params.SearchId = data.SearchId;
                                return data;
                        });
                }

                function fetchExchangeRails(parameters, recommendationId, sectionId, changeableUnits, classification) {
                    const searchParams = this.params.getSearchRequestParams();
                    return railsApiService.searchExchangeEuRails(recommendationId,
                        searchParams.RailTicketSearchSegments[0],
                        sectionId,
                        changeableUnits,
                        classification)
                        .then((data) => {
                            rails = data;
                            _rails[module] = data;
                            this.params.SearchId = data.SearchId;
                            return data;
                        });
                }

                function fetchInwardEuRails(outwardJourneyId, outwardAlternativeIds, searchId) {
                    return railsApiService.searchInwardEuRails(outwardJourneyId, outwardAlternativeIds, searchId)
                        .then((data) => {
                            rails = data;
                            _rails[module] = data;
                            this.params.SearchId = data.SearchId;
                            return data;
                        });
                }

                function fetchPageEuRails(pageId, pageDirection, searchDirection, searchId, isExchangeSearch) {
                    return railsApiService.searchPageEuRails(pageId, pageDirection, searchDirection, searchId, isExchangeSearch)
                        .then((data) => {
                            rails = data;
                            _rails[module] = data;
                            this.params.SearchId = data.SearchId;
                            return data;
                        });
                }

                function findFlights(additionalParams) {
                    // Apply changed params
                    _.extend(this.params, additionalParams);
                    const paramsCopy = angular.copy(this.params);
                    prepareParamsForSearch.call(this, paramsCopy);
                    return fetchRails.call(this, paramsCopy, false);

                    function prepareParamsForSearch(parameters) {
                        parameters.Travelers.Adult = parameters.Travelers.Adult.value;
                        parameters.Travelers.Child = parameters.Travelers.Child.value;
                        parameters.TotalPassengerCount = parseInt(parameters.Travelers.Adult, 10) + parseInt(parameters.Travelers.Child, 10);

                        const departureCode = parameters.RailTicketSearchSegments[0]._departure ? parameters.RailTicketSearchSegments[0]._departure.Code : null;
                        const arrivalCode = parameters.RailTicketSearchSegments[0]._arrival ? parameters.RailTicketSearchSegments[0]._arrival.Code : null;

                        if (parameters.flightType === 'oneway') {
                            parameters.RailTicketSearchSegments = [{
                                DepartureRailStationCode: departureCode,
                                ArrivalRailStationCode: parameters.RailTicketSearchSegments[0]._arrival ? parameters.RailTicketSearchSegments[0]._arrival.Code : null,
                                DepartureDate: moment(parameters.RailTicketSearchSegments[0]._date, regionalSettings.dateFormat)
                                    .format('YYYY-MM-DD'),
                                DepartureHour: parameters.RailTicketSearchSegments[0].DHour.Value,
                                DepartureMinute: parameters.RailTicketSearchSegments[0].DMinutes.Value,
                            }];
                        } else if (parameters.isOpenReturn) {
                                parameters.RailTicketSearchSegments = [{
                                    DepartureRailStationCode: departureCode,
                                    ArrivalRailStationCode: arrivalCode,
                                    DepartureDate: moment(parameters.RailTicketSearchSegments[0]._date, regionalSettings.dateFormat)
                                        .format('YYYY-MM-DD'),
                                    DepartureHour: parameters.RailTicketSearchSegments[0].DHour.Value,
                                    DepartureMinute: parameters.RailTicketSearchSegments[0].DMinutes.Value,
                                }];
                            } else {
                                parameters.RailTicketSearchSegments = [{
                                    DepartureRailStationCode: departureCode,
                                    ArrivalRailStationCode: arrivalCode,
                                    DepartureDate: moment(parameters.RailTicketSearchSegments[0]._date, regionalSettings.dateFormat)
                                        .format('YYYY-MM-DD'),
                                    DepartureHour: parameters.RailTicketSearchSegments[0].DHour.Value,
                                    DepartureMinute: parameters.RailTicketSearchSegments[0].DMinutes.Value,
                                }, {
                                    DepartureRailStationCode: departureCode,
                                    ArrivalRailStationCode: arrivalCode,
                                    DepartureDate: moment(parameters.RailTicketSearchSegments[1]._date, regionalSettings.dateFormat)
                                        .format('YYYY-MM-DD'),
                                    DepartureHour: parameters.RailTicketSearchSegments[1].RHour.Value,
                                    DepartureMinute: parameters.RailTicketSearchSegments[1].RMinutes.Value,
                                }];
                            }
                    }

                }

                /**
                 * Apply filters
                 */
                function applyFilters(filters, comparison) {

                    /**
                     * Save filters to data
                     */
                    this.params.Filters = filters;
                    this.params.resetPagination();

                    const request = this.params.getSearchRequestParams();

                    /**
                     * Update comparison filter
                     */
                    comparisonFilter = comparison;

                    if (comparison) {
                        request.RequestedRecommendationId = comparison;
                    }

                    /**
                     * Get new results from server if needed
                     */
                    $rootScope.$emit(baseEvents.FLIGHT_FILTER_SEARCH_STARTED);
                    railsApiService.search(request).then(
                        function(response) {
                            rails.Recommendations = response.data.Recommendations;
                            rails.FilteredTotal = response.data.FilteredTotal;
                            $rootScope.$emit(baseEvents.FLIGHT_FILTER_SEARCH_ENDED);
                        }
                    );
                }

                /**
                 * Fetch more results
                 */
                function loadMoreFlights() {
                    this.params.adjustPaginationParams(rails.Total);

                    const request = this.params.getSearchRequestParams();

                    if (comparisonFilter) {
                        request.RequestedRecommendationId = comparisonFilter;
                    }

                    railsApiService.search(request).then(
                        function(response) {
                            return rails.Recommendations.push.apply(
                                rails.Recommendations,
                                response.data.Recommendations
                            );
                        }
                    );
                }

                function getTimeOptions(slots) {
                    const format = regionalSettings ? regionalSettings.timeFormat : 'HH:mm';
                    const literalTypes = ['anytime', 'early', 'morning', 'afternoon', 'evening'];

                    return slots.map(function(slot, index) {
                        const dayTime = slot.DayTime.toLowerCase();
                        const label = $filter('capitalize')(dayTime);
                        const startHour = dayTime !== 'anytime'
                                ? moment(slot.From, regionalSettings.mediumTimeFormat).hour()
                                : 0;
                        let text = (_.indexOf(literalTypes, dayTime) !== -1)
                                ? l10nService.localize(label)
                                : moment(label, 'HH:mm').format(format);

                        if (dayTime === 'anytime') {
                            text += '';
                        } else if (_.indexOf(literalTypes, dayTime) !== -1) {
                            text += ' (' + moment(slot.From, regionalSettings.mediumTimeFormat).format(format)
                                + '-' + moment(slot.Till, regionalSettings.mediumTimeFormat).format(format) + ')';
                        } else {
                            text += ' (+/- 1)';
                        }

                        return {
                            text,
                            value: index,
                            startHour,
                        };
                    });
                }

                /**
                 * Filter results by segments
                 */
                function filterBySegment() {
                    this.params.resetPagination();

                    const request = this.params.getSearchRequestParams();
                    railsApiService.search(request).then(
                        function(response) {
                            rails.Recommendations = response.data.Recommendations;
                            rails.FilteredTotal = response.data.FilteredTotal;
                        }
                    );
                }

                function getRules(parameters) {
                    const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');

                    return railsApiService.getRules(parameters).then(
                        function(response) {
                            let rules = response.data.FlightRules;
                            const penalties = _.find(
                                rules, function(rule) {
                                    return (rule.Description === 'Penalties');
                                }
                            );

                            rules = _.filter(
                                rules, function(rule) {
                                    return (rule.Description !== 'Penalties');
                                }
                            );

                            if (penalties) {
                                rules.unshift(penalties);
                            }

                            return {isExist: response.data.HasTextRules, rules, culture: parameters.culture};
                        }
                    ).then(
                        function(rulesResponse) {
                            if (isReadOnlyMode) {
                                return loginFactory.getLocalization(rulesResponse.culture)
                                    .then(
                                        function(localizationResponse) {
                                            l10nService.updateList(localizationResponse);
                                            return rulesResponse;
                                        }
                                    );
                            }

                            return rulesResponse;
                        }
                    );
                }

                /**
                 * Get top rails search requests
                 */
                function getTopPreviousSearches(type) {
                    return railsApiService.getPreviousSearches(this.TOP_PREV_SEARCHES_LIMIT, type);
                }

                /**
                 * Get all rails search requests
                 */
                function getAllPreviousSearches(type) {
                    return railsApiService.getPreviousSearches(this.ALL_PREV_SEARCHES_LIMIT, type);
                }

                function getFrequentRails() {
                    return railsApiService.getFrequentRails()
                        .then(
                            function(response) {
                                return {
                                    from: _.sortBy(response.data.FromLocations, '-UsageCounter')
                                        .slice(0, FREQUENT_FLIGHTS_COUNT),
                                    to: _.sortBy(response.data.ToLocations, '-UsageCounter')
                                        .slice(0, FREQUENT_FLIGHTS_COUNT),
                                };
                            }
                        );
                }

                function getStaticData() {
                    return railsApiService.getStaticData();
                }

                /**
                    Retrieve all rail stations to list
                     @returns {object}
                */
                function getKioskRailStations() {
                    return railsApiService.getKioskRailStations();
                }

                /**
                    Retrieve all corp kiosks to list
                     @returns {object}
                */
                function getAllCorpkiosks() {
                    return railsApiService.getAllCorpkiosks();
                }

                /**
                    Retrieve all corp Printers to list
                     @returns {object}
                */
                function getCorpPrinters() {
                    return railsApiService.getCorpPrinters();
                }

                /**
                 * Return static labels for markup
                 */
                function getLabels() {
                    return labels[module];
                }

                function getModule() {
                    return module;
                }

                function isFlights() {
                    return module === 'flights';
                }

                function isTrains() {
                    return module === 'trains';
                }

                function isUkRail() {
                    return module === 'ukrail';
                }

                function getMaxBookDate() {
                    return this.isUkRail() ? moment().add({days: TRAINLINE_BOOK_DAYS_ADVANCE}) : null;
                }

                function getEarlierOrLaterJournies(parameters, date, time, direction, IsEarlierJourney) {
                    let request = parameters;
                    request = this.params.getSearchRequestParams(false);
                    return railsApiService.getEarlierOrLaterJournies(request, date, time, direction, IsEarlierJourney)
                        .then(({data}) => {
                            rails = data;
                            _rails[module] = data;
                            this.params.SearchId = rails.SearchId;
                            return rails;
                        });
                }

                async function getRailReservationPreferenceOptions() {
                    return railsApiService.getRailReservationPreferenceOptions(0);
                }

                function getRailTravelCardOptions(departureDt) {
                    const date = moment(departureDt, regionalSettings.dateFormat)
                                    .format('YYYY-MM-DD');
                    return railsApiService.getRailTravelCardOptions(1, date, true);
                }

                function getAddressByPostcode(postCode) {
                    return railsApiService.getAddressByPostcode(postCode);
                }

                function getCurrentUKTime() {
                    return railsApiService.getCurrentUKTime();
                }

                function saveAddress(address) {
                    return railsApiService.saveAddress(address);
                }

                function getAddressTypes() {
                    return railsApiService.getAddressTypes();
                }
            };
        }



// WEBPACK FOOTER //
// ./src/app/modules/base/services/railsFactory.js